import { createReducer, on } from '@ngrx/store';

import { UpcomingTripsFetchStatus, UpcomingTripsState } from '../../interfaces/store.interface';
import { UpcomingTripsActions } from '../actions';

export const initialState: UpcomingTripsState = {
  upcomingTrips: undefined,
  status: UpcomingTripsFetchStatus.INITIAL,
};

const upcomingTrips = createReducer(
  initialState,
  on(UpcomingTripsActions.setTrips, (state, { trips, status }) => ({
    ...state,
    upcomingTrips: trips,
    status: status,
  }))
);

export const upcomingTripsReducer = (
  state: UpcomingTripsState,
  action: UpcomingTripsActions.UpcomingTripsActionsUnion
): UpcomingTripsState => {
  return upcomingTrips(state, action);
};
